module.exports = __webpack_public_path__ + "static/media/premium-newsltetters-dark.4d6acb7d.png";